<script setup>
import { useAppStore } from '@/app/stores/app.store.js';
import CFIcon from '@/ui/Icon/CFIcon.vue';

const appStore = useAppStore();
</script>

<template>
    <aside
        id="aside"
        class="fixed inset-y-0 right-0 left-0 z-30 h-full shrink-0 transform transition-transform duration-300 ease-in-out lg:left-0 lg:block lg:w-76"
        :class="[
            appStore.sidebarExpanded ? 'md:left-76 lg:translate-x-76' : 'md:left-24 lg:translate-x-24',
            appStore.contentSidebarOpen ? 'transform-none' : '-translate-x-full',
        ]"
    >
        <div class="bg-grey-light relative h-full overflow-y-auto lg:border-r">
            <div class="absolute top-0 right-0 left-0 flex items-start justify-center lg:hidden">
                <button
                    type="button"
                    class="group z-60 inline-flex cursor-pointer items-center gap-1.5 bg-black px-3.5 py-2 text-white transition-transform select-none hover:scale-125"
                    @click="appStore.contentSidebarOpen = false"
                >
                    {{ $t('general.collapse_menu') }}
                    <CFIcon
                        name="arrow-right"
                        size="14"
                        class="transition-transform duration-200 ease-in-out group-hover:rotate-180"
                    />
                </button>
            </div>

            <div class="mx-auto h-full w-full">
                <slot />
            </div>
        </div>
    </aside>
</template>
